import React,{ useState } from "react";
import Card from "components/card";
import { Bell } from "lucide-react";
import AnnouncementCard from "../../client-dashboard/components/AnnouncementCard";
import { ANNOUNCEMENTS } from "./Announcements"
import AnnouncementWidget from "../../client-dashboard/components/AnnouncementWidget";

const AnnouncementBoard = () => {
    const [selectedId, setSelectedId] = useState(0);

    return (
        <Card className="bg-white text-slate-900 flex flex-col gap-6 rounded-xl border-2 border-slate-200 shadow-sm">
            <div className="grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6 pb-6 bg-slate-50 border-b border-slate-200">
                <div className="flex items-center gap-2">
                    <div className="p-2 rounded-xl bg-purple-100">
                        <Bell className="w-5 h-5 text-purple-600" />
                    </div>
                    <div>
                        <h4 className="text-[18px]">Important Announcements</h4>
                        <p className="text-slate-700 text-[12px]">
                            Stay updated with company news and events
                        </p>
                    </div>
                </div>
            </div>
            <div className="pb-6 p-6">
                <div className="space-y-4">
                    <div className="mb-6 opacity-100 announcement transform-none">
                        {ANNOUNCEMENTS
                            .filter((_, index) => index === selectedId)
                            .map((announcement, index) => (
                            <AnnouncementCard
                                key={index}
                                announcement={announcement}
                                isSelected={true} 
                            />
                            ))
                        }
                    </div>
                    <div className="space-y-2">
                        <div className="flex items-center justify-between mb-2">
                            <h4 className="text-xs text-slate-700 font-semibold">
                                All Announcements
                            </h4>
                            <div className="flex items-center gap-1">
                                {ANNOUNCEMENTS.map((_, index) => (
                                <button
                                    key={index}
                                    onClick={() => setSelectedId(index)}
                                    className={`rounded-full transition-all duration-300 ${
                                    index === selectedId
                                        ? "w-4 h-1.5 bg-violet-600"
                                        : "w-1.5 h-1.5 bg-slate-300 hover:bg-slate-400"
                                    }`}
                                >
                                </button>
                                ))}
                            </div>
                        </div>
                        <AnnouncementWidget
                            announcements={ANNOUNCEMENTS}
                            selectedId={selectedId}
                            setSelectedId={setSelectedId}
                            userType="employee"
                        />
                    </div>
                </div>
            </div>
        </Card>
    )
};
export default AnnouncementBoard;